__turbopack_context__.v({
  "articles": "lcResources-module-scss-module__z54zbq__articles",
  "lcResources": "lcResources-module-scss-module__z54zbq__lcResources",
  "title": "lcResources-module-scss-module__z54zbq__title",
});
